/**
 * Referral API Client
 */

import { http } from './http';

export interface ReferralStats {
  wallet: string;
  referralCode: string;
  totalReferrals: number;
  activeReferrals: number;
  totalEarnings: number;
  pendingEarnings: number;
  topReferee: string | null;
}

export interface ReferralEntry {
  refereeWallet: string;
  referredAt: string;
  matchesPlayed: number;
  totalEarnings: number;
  active: boolean;
}

export async function getReferralStats(wallet: string): Promise<ReferralStats> {
  const response = await http.get<{ stats: ReferralStats }>(`/referrals/${wallet}`);
  return response.stats;
}

export async function getReferralList(wallet: string): Promise<ReferralEntry[]> {
  const response = await http.get<{ referrals: ReferralEntry[] }>(`/referrals/${wallet}/list`);
  return response.referrals;
}

export async function registerReferral(
  code: string,
  wallet: string,
): Promise<{ success: boolean; message: string }> {
  return http.post<{ success: boolean; message: string }>('/referrals/register', { code, wallet });
}

export async function validateReferralCode(
  code: string,
): Promise<{ valid: boolean; referrer: string }> {
  return http.get<{ valid: boolean; referrer: string }>(`/referrals/validate/${code}`);
}

export function getShareableReferralUrl(code: string): string {
  const baseUrl = window.location.origin;
  return `${baseUrl}?ref=${code}`;
}
